import { Box } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { Helmet } from "react-helmet"
import styled from "styled-components"

import { Route } from "helpers/sentry"

const Container = styled(Box).attrs((props) => ({
  contain: props.contain,
  mb: 5,
  px: 2,
}))``

const OrderRoute = ({
  contain,
  component: Component,
  orderUpdateData,
  rmaType,
  title,
  validatePath,
  ...routeProps
}) => (
  <Route
    render={({ location }) => (
      <Container contain={contain}>
        <Helmet>
          <title>{title}</title>
        </Helmet>
        <Component
          location={location}
          orderUpdateData={orderUpdateData}
          rmaType={rmaType}
          validatePath={validatePath}
        />
      </Container>
    )}
    {...routeProps}
  />
)

OrderRoute.propTypes = {
  component: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.elementType,
    PropTypes.node,
  ]).isRequired,
  contain: PropTypes.bool,
  orderUpdateData: PropTypes.object,
  rmaType: PropTypes.string,
  title: PropTypes.string.isRequired,
  validatePath: PropTypes.string,
}

export default OrderRoute
